import { service } from '@maia/broker';
import { queryOptions } from '@tanstack/react-query';

export function getSelf() {
  return queryOptions({
    queryKey: ['getSelf'],
    queryFn: () => service.getSelf(),
    staleTime: Infinity,
  });
}
